import { RefObject } from 'react';

export function scrollToRef(
  ref: RefObject<HTMLElement | null>,
  position: 'top' | 'bottom' = 'top',
  additionalOffset = 24,
  /** In some cases we may prefer to use scrollIntoView, allows forcing of this behavior. Example, scrolling inside modals is more reliable via this approach */
  forceScrollIntoView: boolean = false
): void {
  if (
    (!forceScrollIntoView &&
      position === 'top' &&
      ref.current?.getBoundingClientRect().top) ||
    (position === 'bottom' && ref.current?.getBoundingClientRect().bottom)
  ) {
    if (position === 'top') {
      window.scrollTo({
        top: ref.current?.getBoundingClientRect().top + window.scrollY - additionalOffset,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top:
          ref.current?.getBoundingClientRect().bottom -
          window.innerHeight +
          window.scrollY +
          additionalOffset,
        behavior: 'smooth',
      });
    }
  } else {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }
}
